import { forwardRef } from 'react'
import { cn } from '@/lib/utils'

// Main BottomBar component
const BottomBar = forwardRef(({ children, className, ...props }, ref) => {
  return (
    <footer
      ref={ref}
      className={cn(
        'sticky bottom-0 left-0 shrink-0',
        'bg-light-secondary min-h-[20px]',
        'flex items-center justify-between',
        'z-[4000] px-6 py-2',
        'transition-all duration-300 ease-out',
        className,
      )}
      {...props}
    >
      {children}
    </footer>
  )
})
BottomBar.displayName = 'BottomBar'

// Content component for left-aligned content
const BottomBarContent = forwardRef(({ children, className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'flex items-center gap-4',
        'flex-shrink-0',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
})
BottomBarContent.displayName = 'BottomBar.Content'

// Actions container for right-aligned actions
const BottomBarActions = forwardRef(({ children, className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'flex items-center gap-3',
        'ml-auto',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
})
BottomBarActions.displayName = 'BottomBar.Actions'

// Section for middle content
const BottomBarSection = forwardRef(({ children, className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'flex items-center',
        'flex-1',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
})
BottomBarSection.displayName = 'BottomBar.Section'

// Export compound component
BottomBar.Content = BottomBarContent
BottomBar.Actions = BottomBarActions
BottomBar.Section = BottomBarSection

export default BottomBar
export { BottomBar, BottomBarActions, BottomBarContent, BottomBarSection }
